import { PatientConsentDocumentAttachment } from '@dreryk/egabinet-patient-frontend-api';

import { AttachmentsLinks } from '../../../../shared/AttachmentLinks/AttachmentsLinks';
import { ConsentsAndAuthorizationsDocumentAttachmentsModalOpener } from '../../ConsentsAndAuthorizationsDocumentAttachmentsModal/ConsentsAndAuthorizationsDocumentAttachmentsModal.opener';
import { mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments } from '../../../../shared/AttachmentLinks/AttachmentsLinks.utils';

type ScanDocumentAttachmentLinksCellProps = {
   readonly consentDocumentName: string;
   readonly attachments: PatientConsentDocumentAttachment[];
};

export const ScanDocumentAttachmentLinksCell = (props: ScanDocumentAttachmentLinksCellProps): JSX.Element => {
   return (
      <ConsentsAndAuthorizationsDocumentAttachmentsModalOpener
         name={props.consentDocumentName}
         attachments={props.attachments}
      >
         {({ openModal }) => (
            <AttachmentsLinks
               attachments={mapPatientConsentDocumentAttachmentsToMedicalInformationAttachments(props.attachments)}
               onShowMoreAttachmentsClick={openModal}
            />
         )}
      </ConsentsAndAuthorizationsDocumentAttachmentsModalOpener>
   );
};
